<template>
  <section :style="{ color: visualSettings.verifiedIconColor }">
    <fa-icon 
      :icon="['fas', 'certificate']" 
      size="lg"
    />
    <div class="check">
      <div class="v-align">
        <div class="inner">
          <fa-icon 
            :icon="['fas', 'check']" 
            size="lg"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'VerifiedIcon',
  computed: {
    ...mapGetters([
      'visualSettings'
    ])
  }
}
</script>

<style scoped lang="scss">
section {
  position: relative;
  display: inline-block;
  font-size: 13px;
  color: royalblue;
  margin: -2px 0;

  .check {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    > .v-align {
      display: table;
      width: 100%;
      height: 100%;
      text-align: center;
      color: #fff;
      font-size: 7px;
      line-height: 7px;

      > .inner {
        display: table-cell;
        vertical-align: middle;
      }
    }
  }
}
</style>
